import noop from 'lodash/noop';

export const defaultProps = {
  dashboardType: null,
  savedFilters: [],
  router: {},
  selectedFilters: [],
  modal: {},
  updateActiveTab: noop,
  updateSelectedFilters: noop,
  maxSelectedFilters: 1,
  resetDrillDown: noop,
  pushDrilldownFilter: noop,
  addSavedFilters: noop,
  applyFilter: noop,
  changeFilterContainerVisibility: noop,
  getFilters: noop,
  toggleModal: noop,
  dashboardId: null,
};
